module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.work.blocked != '1') ? _c('div', {
    staticClass: "box__btn box__btn_wrap"
  }, [_c('div', {
    staticClass: "box__btn_doc-clinic",
    class: {
      'gray': _vm.work.can == 'no'
    },
    on: {
      "click": function($event) {
        _vm.appointment(_vm.work)
      }
    }
  }, [(_vm.work.can == 'yes') ? _c('p', [_vm._v("Быстрая запись")]) : (_vm.work.can == 'by_request') ? _c('p', [_vm._v("Оставить заявку")]) : (_vm.work.can == 'no') ? _c('p', {
    staticClass: "gray"
  }, [_vm._v("Запись по телефону")]) : _c('p', [_vm._v("Оставить заявку")])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b75466f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreateVisitButton.vue
// module id = 577
// module chunks = 0